import type {
  ClientsColumnType,
  ClientsFilterObject,
  UsersV2FilterObject,
} from '@/_types/clients';

export const DEFAULT_CLIENT_COLUMNS: Array<ClientsColumnType> = [
  'select',
  'client',
  'client_email',
  'client_phone_number',
  'contact_tags',
  'assigned_advisor_id',
  'actions',
];

export const DEFAULT_CLIENT_FILTER: ClientsFilterObject = {
  assigned_advisor_id: -1,
  entity_type: '',
  firm_group_id: -1,
  hide_actives: false,
  hide_inactives: false,
  search_term: '',
  selected_client_tags_filter: [],
};

export const DEFAULT_V2_USERS_FILTER: UsersV2FilterObject = {
  assigned_advisor_id: -1,
  firm_group_id: -1,
  hide_actives: false,
  hide_inactives: false,
  selected_client_tags_filter: [],
  show_only_deleted: false,

  count: false,
  descending: true,
  page: 0,
  rows_per_page: 10,
  search_term: '',
  sort_by: 'created_at',
};

export const CLIENTS_TABLE_HEADER_MAP: Record<ClientsColumnType, string> = {
  actions: '',
  assigned_advisor_id: 'Assigned Firm User',
  client: 'Name',
  client_email: 'Email',
  external_user_id: 'External User ID',
  contact_tags: 'Tags',
  client_phone_number: 'Phone Number',
  select: '',
};
